export const isE2E = (): boolean => {
  return !!(window as any)?.isPlaywrightRunning;
};
